import FormConsentCheckbox from './form-consent-checkbox';
import RetailerFormFields from './retailer-form-fields';
import { FormHeader } from './form-header';
import { FormProvider, useFormContext } from './context';
import { retailerApplicationApi } from '../../store/retailer-application-api';
import Dialog from './dialog';
import { getClassNamesFromArray } from '@common/utils';
const {
  Form
} = svs.ui.reactForm;
const {
  Button
} = svs.ui;
const {
  ReactBrand: Brand
} = svs.ui;
const RetailerFormContent = () => {
  const {
    validateForm,
    formData,
    resetForm,
    setFormData
  } = useFormContext();
  const [addApplication, {
    isLoading
  }] = retailerApplicationApi.useAddApplicationMutation();
  const [dialogVisible, setDialogVisible] = React.useState(false);
  const [dialogTitle, setDialogTitle] = React.useState('');
  const [dialogSubtitle, setDialogSubtitle] = React.useState('');
  const getDialogMessage = errorTypes => {
    const hasRequired = errorTypes.includes('required');
    const hasOrg = errorTypes.includes('orgNumber');
    const hasSsn = errorTypes.includes('ssn');
    if (hasRequired && hasOrg && hasSsn) {
      return 'Kontrollera att alla obligatoriska fält är ifyllda och att organisationsnummer samt personnummer är giltiga.';
    } else if (hasRequired && hasOrg) {
      return 'Kontrollera att alla obligatoriska fält är ifyllda och att organisationsnummer är giltigt.';
    } else if (hasRequired && hasSsn) {
      return 'Kontrollera att alla obligatoriska fält är ifyllda och att personnummer är giltigt.';
    } else if (hasOrg && hasSsn) {
      return 'Kontrollera att organisationsnummer och personnummer är giltiga.';
    } else if (hasRequired) {
      return 'Kontrollera att alla obligatoriska fält är ifyllda.';
    } else if (hasOrg) {
      return 'Kontrollera att organisationsnummer är giltigt.';
    } else if (hasSsn) {
      return 'Kontrollera att personnummer är giltigt.';
    }
    return '';
  };
  const handleSubmit = async e => {
    e.preventDefault();
    if (formData.website) {
      return;
    }
    const submissionData = {
      ...formData,
      turnoverMSek: formData.turnoverMSek.replace(',', '.')
    };
    const errorTypes = validateForm();
    if (errorTypes.length > 0) {
      setDialogTitle('Fel');
      setDialogSubtitle(getDialogMessage(errorTypes));
      setDialogVisible(true);
      return;
    }
    try {
      await addApplication(submissionData).unwrap();
      resetForm();
      setDialogTitle('Tack');
      setDialogSubtitle('Vi har mottagit din ansökan och återkommer i ärendet');
      setDialogVisible(true);
    } catch (error) {
      if (error?.status === 409 || error?.data?.errorCode === '900409') {
        setDialogTitle('Duplicerad ansökan');
        setDialogSubtitle('En ansökan med samma uppgifter har redan skickats.');
      } else {
        setDialogTitle('Något gick fel');
        setDialogSubtitle('Försök igen senare eller kontakta support.');
      }
      setDialogVisible(true);
    }
  };
  return <React.Fragment>
      <Dialog confirmLabel="OK" hasIcon isOpen={dialogVisible} onClose={() => setDialogVisible(false)} onConfirm={() => setDialogVisible(false)} subtitle={dialogSubtitle} title={dialogTitle} />
      <Form className="u-flex u-flex-column margin-h-0" onSubmit={handleSubmit}>
        {}
        <input autoComplete="off" name="website" onChange={e => setFormData({
        ...formData,
        website: e.target.value
      })} style={{
        display: 'none'
      }} type="text" value={formData.website || ''} />

        <RetailerFormFields />
        <FormConsentCheckbox />
        <div className="u-flex u-flex-justify-content-end">
          <Button disabled={isLoading} inverted type="submit">
            {isLoading ? 'Skickar...' : 'Skicka'}
          </Button>
        </div>
      </Form>
    </React.Fragment>;
};
export const RetailerForm = () => <React.Fragment>
    <div className={getClassNamesFromArray(['page-header page-header-container bg-red-100'])} style={{
    height: '88px'
  }}>
      <div className="ompo-main-content u-flex" style={{
      alignItems: 'center',
      height: '100%'
    }}>
        <Brand brand="svenskaspel-twolines" emblem size={200} />
      </div>
    </div>
    <div className="ompo-main-content margin-bottom-4">
      <FormHeader />
      <FormProvider>
        <RetailerFormContent />
      </FormProvider>
    </div>
  </React.Fragment>;